import { render, staticRenderFns } from "./FieldFeature.vue?vue&type=template&id=036892fe&scoped=true&"
import script from "./FieldFeature.vue?vue&type=script&lang=js&"
export * from "./FieldFeature.vue?vue&type=script&lang=js&"
import style0 from "./FieldFeature.vue?vue&type=style&index=0&id=036892fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036892fe",
  null
  
)

export default component.exports